import React, {useState, useEffect} from "react"
import {useNavigate, useParams} from "react-router-dom"
import {FunctionComponent} from "react"
import {CustomerBlockDto} from "../api/models"
import {IconContext} from "react-icons/lib"
import {TbUsersGroup, TbBuildingBank, TbMessages} from "react-icons/tb"
import {RiCalendarEventFill} from "react-icons/ri"
import {LuPencilRuler} from "react-icons/lu"
import {useUserPreferences} from "../../../common/contexts/UserPreferencesContext"
import {useCustomer} from "../../../common/contexts/CustomerContext"

interface LevelRowProps {
	category: string
	cards: CustomerBlockDto[]
	categoryId: number
}

const LevelRow: FunctionComponent<LevelRowProps> = ({category, cards, categoryId}) => {
	const [completed, setCompleted] = useState(0)

	const navigate = useNavigate()
	let {customerId} = useParams()

	const {customer} = useCustomer()

	if (!customerId) customerId = customer.Id

	useEffect(() => {
		setCompleted(cards.filter(card => card.RequirementStatus == 4).length)
	}, [cards])

	const {translations} = useUserPreferences()
	const populateClasses = (card: CustomerBlockDto) => {
		let baseClass = "level-card"

		if (card.RequirementStatus === 4) {
			baseClass += " level-card--completed"
		}

		//baseClass += ` level-card--cat${categoryId}`;
		// Append the level class, e.g. "level-1", "level-2", etc.
		baseClass += ` level-${card.RequirementStatus}`

		return baseClass
	}

	const handleClick = (id: number) => {
		navigate(`/questionnaire/${customerId}/${id}`)
	}

	const icon = (categoryId: number) => {
		switch (categoryId) {
			case 1:
				return (
					<IconContext.Provider value={{className: "levelview-icon"}}>
						<TbUsersGroup />
					</IconContext.Provider>
				)
			case 2:
				return (
					<IconContext.Provider value={{className: "levelview-icon"}}>
						<TbBuildingBank />
					</IconContext.Provider>
				)
			case 3:
				return (
					<IconContext.Provider value={{className: "levelview-icon"}}>
						<RiCalendarEventFill />
					</IconContext.Provider>
				)
			case 4:
				return (
					<IconContext.Provider value={{className: "levelview-icon"}}>
						<LuPencilRuler />
					</IconContext.Provider>
				)
			case 5:
				return (
					<IconContext.Provider value={{className: "levelview-icon"}}>
						<TbMessages />
					</IconContext.Provider>
				)
			default:
				return null
		}
	}

	return (
		<div className='level-row'>
			<div className='level-block'>
				<div className='level-icon'>{icon(categoryId)}</div>
				<div className='level-text'>
					<div className='level-name'>{category}</div>
					<div className='completed-count'>
						{`${completed}/${cards.length} `}
						{translations.tmsCompleted || "completed"}
					</div>
				</div>
			</div>

			{cards.map(card => (
				<div className={populateClasses(card)} onClick={() => handleClick(card.Id)} key={card.Id}>
					{card.Name}
					{/* Three small boxes */}
					<div className='level-boxes'>
						<div className='level-box'></div>
						<div className='level-box'></div>
						<div className='level-box'></div>
					</div>
				</div>
			))}
		</div>
	)
}

export default LevelRow
